import { composeDataModules } from '@perpay-web/data-module/composeDataModules';
import { fetchCardAccountApplicationForOnboardingDataModule } from '@perpay-web/fintech/dataModules/fetchCardAccountApplicationForOnboarding';
import { fetchFeaturesForOnboardingDataModule } from '@perpay-web/fintech/dataModules/fetchFeaturesForOnboarding';
import { fetchUserInfoDataModule } from '@perpay-web/fintech/dataModules/fetchUserInfo';
import { fetchUserStatusDataModule } from '@perpay-web/fintech/dataModules/fetchUserStatus';
import { gateCardApplyDataModule } from '@perpay-web/fintech/dataModules/gateCardApply';

const CardOnboardingSwitcherDataModule = composeDataModules([
    fetchUserStatusDataModule,
    fetchFeaturesForOnboardingDataModule,
    fetchCardAccountApplicationForOnboardingDataModule,
    fetchUserInfoDataModule,
    gateCardApplyDataModule,
]);

const getRoot = (state) => state.dataModules.cardOnboardingSwitcher;

export const cardOnboardingSwitcherDataModule =
    CardOnboardingSwitcherDataModule({
        getRoot,
        key: 'CARD_ONBOARDING_SWITCHER',
    });
